
export const DEVELOPER_NAME = process.env.REACT_APP_DEVELOPER

export const DEVELOPER_PHONE = process.env.REACT_APP_DEVELOPER_PHONE

export const APP_URL = process.env.REACT_APP_URL

export const API_URL = process.env.REACT_APP_API_URL

export const ESTABLISHMENT_NAME = process.env.REACT_APP_ESTABLISHMENT_NAME